import { formatDate } from "../_helpers";
import { QUESTIONNAIRE_TEMPLATE } from "../_constants/questionnaireTemplate.constant";
import { getQuestionnaireTemplates } from "../apis/questionnaireApis";


const questionnaireClearTemplateStore = () => {
    return {
        type: QUESTIONNAIRE_TEMPLATE.CLEAR,
    };
}
const questionnaireFetchTemplateLists = (t) => {
 
    return async (dispatch) => {
        dispatch({ type: QUESTIONNAIRE_TEMPLATE.SET_TEMPLATE_LIST_LOADING, data: true });
        try {
            
            const res = await getQuestionnaireTemplates()
            const resData = res?.data || [];
            const data = resData.map((item) => ({
                ...item,
                 searchField: `${formatDate(new Date(item.modifiedOn))}   ${formatDate(new Date(item.createdOn))} ${item.active ? t("general.yes") : t("general.no")}`
            }));  
              dispatch({
                type: QUESTIONNAIRE_TEMPLATE.SET_TEMPLATE_LIST, data: {
                    loading: false,
                    data
                }
            });
        } catch (e) {
            dispatch({ type: QUESTIONNAIRE_TEMPLATE.SET_TEMPLATE_LIST_LOADING, data: false });
        }
    }
}

export const questionnaireTemplateActions = {
    questionnaireFetchTemplateLists,
    questionnaireClearTemplateStore
}